import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'antd'
import StockroomsTable from '../StockroomsTable'
import AddStockroomModal from '../AddStockroomModal'
import { getStockroomsAction } from '../../../store/stockroom'

const StockroomsTabView = () => {
  const dispatch = useDispatch()
  const [showStockroomModal, setShowStockroomModal] = useState(false)

  const onNewStockroom = useCallback(() => {
    dispatch(getStockroomsAction({ pagination: { page: 1, pageSize: 10 } }))
    hideModal()
  }, [dispatch])

  const showModal = useCallback(() => setShowStockroomModal(true), [])
  const hideModal = useCallback(() => setShowStockroomModal(false), [])

  return (
    <div>
      <div style={{ paddingTop: 10, display: 'block' }}>
        <Button type="primary" onClick={showModal} style={{ float: 'right', zIndex: 99 }}>
          Создать новый склад
        </Button>
      </div>
      <StockroomsTable />
      <AddStockroomModal showModal={showStockroomModal} onCancel={hideModal} onFinish={onNewStockroom} />
    </div>
  )
}

export default StockroomsTabView
